var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnhideIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ohen3jqq1a",
    d: "M2.4 5.1h14.4V2.4H2.4v2.7zm10.643 8.071H9.82v2.205l-3.663-3.491L9.82 8.378V10.6h3.223v2.571zM16.8.6H2.4C1.5.6.6 1.41.6 2.4v2.708c0 .648.388 1.206.9 1.522V16.8c0 .99.99 1.8 1.8 1.8h12.6c.81 0 1.8-.81 1.8-1.8V6.63c.514-.316.9-.874.9-1.522V2.4c0-.99-.9-1.8-1.8-1.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-622 -725) translate(0 707) translate(622 18) translate(2.4 2.4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u5zr5p1ctb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ohen3jqq1a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#5F7191",
    xlinkHref: "#ohen3jqq1a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5F7292",
    mask: "url(#u5zr5p1ctb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-2.4 -2.4)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhideIcon);
export default __webpack_public_path__ + "static/media/unhide-icon.5f8ab68e1516c7a8b5cb0406179c20e3.svg";
export { ForwardRef as ReactComponent };